import { ImportStep } from "@/components/ImportComponents/types";
import {
  ADDING_KEY,
  ADDING_STEP,
  DOWNLOAD_KEY,
  DOWNLOAD_STEP,
  MAPPING_STEP,
  MAP_KEY,
  UPLOAD_KEY,
  UPLOAD_STEP,
  VALIDATE_KEY,
  VALIDATE_STEP,
} from "@/pages/infrastructure/import/importSteps";

export const getImportSteps = (): ImportStep[] => {
  return [
    {
      ...DOWNLOAD_STEP,
      key: `${DOWNLOAD_KEY}-events`,
      helpSectionKey: `${DOWNLOAD_KEY}-events`,
    },
    {
      ...UPLOAD_STEP,
      key: UPLOAD_KEY,
      helpSectionKey: `${UPLOAD_KEY}-events`,
    },
    {
      ...MAPPING_STEP,
      key: MAP_KEY,
      helpSectionKey: `${MAP_KEY}-events`,
    },
    {
      ...VALIDATE_STEP,
      key: VALIDATE_KEY,
      helpSectionKey: `${VALIDATE_KEY}-events`,
    },
    {
      ...ADDING_STEP,
      key: ADDING_KEY,
      helpSectionKey: `${ADDING_KEY}-events`,
    },
  ];
};
